export default "__VITE_ASSET__DohoS79z__"